/** L'arbre n'est remplacé que sur la première étape, sans fichier et sans écart avec le modèle. */
export function folderTreeUntouched(input: {
  position: number;
  fileCount: number;
  hasNestedFolder: boolean;
  folderNames: readonly string[];
  templateNames: readonly string[];
}): boolean {
  if (input.position !== 1 || input.fileCount > 0 || input.hasNestedFolder) return false;
  const left = [...input.folderNames].sort();
  const right = [...input.templateNames].sort();
  return left.length === right.length && left.every((name, index) => name === right[index]);
}

export function correctionLabel(familyName: string, friseName: string, stepLabel: string): string {
  return `Correction · ${familyName} — ${friseName} · ${stepLabel}`;
}

export function landingCloses(position: number, stepCount: number): boolean {
  return stepCount > 0 && position === stepCount;
}
